import { MessageSquare, CheckSquare, AlignLeft, Check, Paperclip } from "lucide-react";
import { Avatar } from "./Avatar";
import { STATUSER, sorterSaker, fristInfo, FRIST_KLASSE, medlem, PRI } from "./sakerUtils";

const Rad = ({ sak, members, today, onOpen, onStatus }) => {
  const frist = fristInfo(sak.dueDate, today);
  const ansvarlig = medlem(members, sak.assigneeId);
  const delFerdig = (sak.subtasks || []).filter((s) => s.done).length;
  const delTotal = (sak.subtasks || []).length;
  const pri = PRI[sak.priority || 2];
  const ferdig = sak.status === "done";

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onOpen(sak.id)}
      onKeyDown={(e) => { if (e.key === "Enter") onOpen(sak.id); }}
      className="w-full flex items-center gap-3 px-1.5 sm:px-2 py-2.5 text-left border-t border-neutral-100 hover:bg-neutral-50 transition-colors group cursor-pointer"
      data-testid={`saker-rad-${sak.id}`}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onStatus(sak.id, ferdig ? "inbox" : "done"); }}
        className={`w-[17px] h-[17px] rounded-full border-[1.5px] shrink-0 flex items-center justify-center transition-all ${
          ferdig
            ? "bg-emerald-500 border-emerald-500 text-white"
            : "border-neutral-300 text-transparent hover:border-emerald-500 hover:text-emerald-500 hover:scale-110"
        }`}
        title={ferdig ? "Gjenåpne saken" : "Marker som ferdig"}
        data-testid={`saker-rad-check-${sak.id}`}
      >
        <Check size={11} strokeWidth={2.6} />
      </button>
      {sak.priority !== 2 ? (
        <span className="bud-mono text-[10px] font-bold w-6 shrink-0" style={{ color: pri.farge }}>{pri.kort}</span>
      ) : (
        <span className="w-6 shrink-0" />
      )}
      <span className={`flex-1 text-[13.5px] font-medium text-neutral-900 truncate ${ferdig ? "line-through text-neutral-400" : ""}`}>
        {sak.title}
      </span>
      {sak.description && <AlignLeft size={11} strokeWidth={2.2} className="hidden sm:block text-neutral-300 shrink-0" />}
      {(sak.labels || []).slice(0, 3).map((l) => (
        <span key={l} className="hidden md:inline text-[10px] font-medium text-neutral-500 border border-[#E7E4DB] rounded-full px-1.5 py-px shrink-0">
          {l}
        </span>
      ))}
      {delTotal > 0 && (
        <span className={`hidden sm:inline-flex items-center gap-1 text-[11px] shrink-0 ${delFerdig === delTotal ? "text-emerald-600" : "text-neutral-400"}`}>
          <CheckSquare size={11} strokeWidth={2.2} /> {delFerdig}/{delTotal}
        </span>
      )}
      {(sak.attachments || []).length > 0 && (
        <span className="hidden sm:inline-flex items-center gap-1 text-[11px] text-neutral-400 shrink-0">
          <Paperclip size={11} strokeWidth={2.2} /> {sak.attachments.length}
        </span>
      )}
      {(sak.comments || []).length > 0 && (
        <span className="hidden sm:inline-flex items-center gap-1 text-[11px] text-neutral-400 shrink-0">
          <MessageSquare size={11} strokeWidth={2.2} /> {sak.comments.length}
        </span>
      )}
      {frist && !ferdig && (
        <span className={`bud-mono text-[10px] font-semibold px-1.5 py-0.5 rounded shrink-0 ${FRIST_KLASSE[frist.tone]}`}>
          {frist.label}
        </span>
      )}
      <span className="w-6 shrink-0 flex justify-end">
        {ansvarlig && <Avatar person={ansvarlig} size={22} />}
      </span>
    </div>
  );
};

export const TaskListe = ({ saker, members, today, onOpen, onStatus }) => (
  <div className="space-y-8" data-testid="saker-liste">
    {STATUSER.map((s) => {
      const gruppe = saker.filter((t) => (t.status || "inbox") === s.k).sort(sorterSaker);
      if (!gruppe.length) return null;
      return (
        <div key={s.k}>
          <div className="flex items-center gap-2 px-1.5 sm:px-2 pb-2 border-b border-[#E7E4DB]">
            <span className="w-2 h-2 rounded-full" style={{ background: s.dot }} />
            <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-neutral-500">{s.label}</span>
            <span className="bud-mono text-[10.5px] tabular-nums text-neutral-400">{gruppe.length}</span>
          </div>
          {gruppe.map((sak) => (
            <Rad key={sak.id} sak={sak} members={members} today={today} onOpen={onOpen} onStatus={onStatus} />
          ))}
        </div>
      );
    })}
    {saker.length === 0 && (
      <p className="text-center text-sm text-neutral-400 py-16" data-testid="saker-liste-tom">Ingen saker å vise.</p>
    )}
  </div>
);
